import { useState } from "react";
import {
  LeagueEpisodesTable as LeagueEpisodesTableView,
  type EpisodeSort,
} from "@softmax/product-ux/play";
import {
  activityTimeZone,
  formatRelative,
} from "../lib/activity/feed-calendar";
import type { LeagueEpisodeRow } from "../lib/types";

export function LeagueEpisodesTable({
  rows,
  now,
  allEpisodesHref,
  maxRows = 5,
}: {
  readonly rows: readonly LeagueEpisodeRow[];
  readonly now: string;
  readonly allEpisodesHref: string | null;
  readonly maxRows?: number;
}) {
  const [sort, setSort] = useState<EpisodeSort>("newest");
  const sorted =
    sort === "score"
      ? rows.toSorted((a, b) => (b.topScore ?? 0) - (a.topScore ?? 0))
      : rows;

  return (
    <LeagueEpisodesTableView
      rows={sorted.slice(0, maxRows).map((row) => ({
        ...row,
        when: formatRelative({
          iso: row.createdAt,
          now,
          timeZone: activityTimeZone,
        }),
      }))}
      sort={sort}
      onSortChange={setSort}
      footer={`${rows.length} episode${rows.length === 1 ? "" : "s"} in the latest round`}
      allEpisodesHref={allEpisodesHref}
    />
  );
}
